'use client';
import { useEffect } from 'react';
import { captureClickIds } from '@/lib/clickIds';

export default function ClickIdCapture() {
	useEffect(() => {
		captureClickIds();
	}, []);
	return null;
}
